export default {
    CUSTOMER_SERVICE: {
        PHONE: {
            UK: '+442895810710',
            PL: '+48587358181'
        },
        EMAIL: {
            UK: 'help@easysend.pl',
            PL: 'pomoc@easysend.pl'
        }
    },
    BASE_URL: 'https://www.easysend.pl',
    HOTJAR_ID: 65540,
    HOTJAR_ID_BUSINESS: 1199186,
//    FEEDBACK_WIDGET_ID: 'cbaa63e4-bb41-11e8-aadd-0288f735e5b9',
    GOOGLE_ANALYTICS_ID: null,
    THREEDS_CONFIRMATION_URL: 'https://www.easysend.pl/panel/3ds_confirmation',
    WORLDPAY_KEY: 'L_C_edd91144-328a-4e40-857c-2ea5e818115a',
    CHECKOUT_KEY_GB: 'pk_egizxuh22d5yzfxojy3oas3vxac',
    CHECKOUT_KEY_SAS: 'pk_f3hx7qoxj4ou5ws56444jmxxqqv',
//    CHECKOUT_KEY_GB: 'pk_600f3bfd-6c7b-45ce-81fc-4ca6a0a60c94',
//    CHECKOUT_KEY_SAS: 'pk_33c3c143-6bec-4929-8b8e-b73e24ecdfdf',
    CLIENT_ID: '1_z67gk8vcinks4s8o000wkcg0gcwwkkgwk4sg80cow44kw0k84',
    CLIENT_SECRET: '40nragj6o78ksgos4kw44480cwo4co8s0skccwk0wc044gcok0',
    PRODUCTION: true,
    RAVEN: {
        DSN: 'https://09aea0aab31f4e5a9ca09b6d0c9ff915@wtf.easysend.pl/2',
        CONFIG: {
            ignoreErrors: [
                'top.GLOBALS',
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                'Can\'t find variable: ZiteReader',
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                'fb_xd_fragment',
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                'conduitPage',
                'Script error.'
            ],
            ignoreUrls: [
                /graph\.facebook\.com/i,
                /connect\.facebook\.net\/en_US\/all\.js/i,
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                /extensions\//i,
                /^chrome:\/\//i,
                /127\.0\.0\.1:4001\/isrunning/i,
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
            ],
            whitelistUrls: [
                /easysend\.pl\/app/,
                /easysend\.lt\/app/,
                /app.easysend\.pl/
            ],
            release: APP_VERSION //eslint-disable-line
        }
    },
    WEBSITE_URI: 'https://www.easysend.pl',
    FACEBOOK_APP_ID: '223818044475604',
    GOOGLE_APP_ID: '788269904969-tod0h2ri156oe6ckba1pvpqjm9snpnph.apps.googleusercontent.com',
    FACEBOOK_LOGIN_AVAILABLE: true,
    GOOGLE_LOGIN_AVAILABLE: true,
    NETVERIFY_REDIRECT_URL: 'https://easysend.lon.netverify.com/**',
    PUSHER: {
        APP_ID: '5eef43bb3e8e6955d246',
        CLUSTER: 'eu'
    },
    RECAPTCHA_CLIENT_PANEL_SITE_PUBLIC_KEY: '6Lf744AdAAAAAOXWI4LpnYi5riOTsEXODVd2ataI',
    RECAPTCHA_ENABLE: true,
    FIREBASE: {
        apiKey: 'AIzaSyC4xjBz2EwPpmTZYGHLOl3jo8pVTI6WFaI',
        authDomain: 'mercurial-kit-182812-c683b.firebaseapp.com',
        databaseURL: 'https://mercurial-kit-182812-c683b.firebaseio.com',
        projectId: 'mercurial-kit-182812',
        storageBucket: 'mercurial-kit-182812.appspot.com',
        messagingSenderId: '788269904969',
        appId: '1:788269904969:web:b75aa104133738cb447b98',
        measurementId: 'G-NPD11HHNHB'
    }
};



//////////////////
// WEBPACK FOOTER
// /home/app/www/shared/src/app/config/parameters.js
// module id = 184
// module chunks = 2